import privacyEn from "./content/privacy.en.md?raw";
import privacyEs from "./content/privacy.es.md?raw";
import privacyFr from "./content/privacy.fr.md?raw";
import termsEn from "./content/terms.en.md?raw";
import termsEs from "./content/terms.es.md?raw";
import termsFr from "./content/terms.fr.md?raw";

export const LEGAL_PATHS = {
  privacy: "/privacy",
  terms: "/terms",
} as const;

export type LegalDocumentId = keyof typeof LEGAL_PATHS;
export type LegalLocale = "fr" | "en" | "es";

const DOCUMENTS: Record<LegalDocumentId, Record<LegalLocale, string>> = {
  privacy: { fr: privacyFr, en: privacyEn, es: privacyEs },
  terms: { fr: termsFr, en: termsEn, es: termsEs },
};

export function resolveLegalLocale(language: string | undefined): LegalLocale {
  const code = (language || "fr").slice(0, 2).toLowerCase();
  if (code === "es") return "es";
  if (code === "en") return "en";
  return "fr";
}

export function getLegalMarkdown(document: LegalDocumentId, language?: string): string {
  return DOCUMENTS[document][resolveLegalLocale(language)];
}
